import { cva, type VariantProps } from 'class-variance-authority';

export const cardVariants = cva(
  'flex flex-col gap-e lg:rounded-rad-c lg:border lg:border-gray-200 bg-white p-e border-x border-b border-white',
  {
    variants: {
      planType: {
        default: 'product-plan-default',
        'ev-day': 'product-plan-ev-day',
        'ev-day-saver': 'product-plan-ev-day-saver',
        'ev-night': 'product-plan-ev-night',
        'ev-night-saver': 'product-plan-ev-night-saver',
        solar: 'product-plan-solar',
        sustainable: 'product-plan-sustainable',
        power: 'product-plan-power',
        gas: 'product-plan-gas',
        'gas-power-house': 'product-plan-gas-power-house',
      },
      variant: {
        banner: 'rounded-rad-b box-shadow bg-white overflow-hidden',
        minimal: '',
      },
    },
    defaultVariants: {
      planType: 'default',
      variant: 'minimal',
    },
  }
);

export type CardVariants = VariantProps<typeof cardVariants>;
